import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({ eyebrow, title, desc, moreTo, moreLabel }: SectionTitleProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-400" aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel ?? "查看全部"}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}